module.exports = __webpack_public_path__ + "assets/d4a5c6a3f8c8e34e8ac592ed02b49592.png";